import React from 'react';
import AnimalCard from "./Components/AnimalCard";
import useAnimalSponsorships from "./hooks/useAnimalSponsorships";

export const AnimalSponsorshipApp: React.FC = () => {

    const {
        loading
        , error
        , species
        , selectedSpecies
        , toggleSpecies
        , selectedStatus
        , setSelectedStatus
        , conservation
        , displayedAnimals
        , pageIncrement
        , showLoadMore
        , search
        , dictionary
    } = useAnimalSponsorships();

    if (loading) {
        //"width: 3rem; height: 3rem;"
        return <div className="m-4 d-flex justify-content-center">
            <div className="spinner-border" style={{width: '3rem', height: '3rem'}} role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div>;
    }

    if (error) {
        return <div className="m-4 d-flex justify-content-center">
            <div className="alert alert-danger w-75" role="alert">
                {error}
            </div>
        </div>;
    }

    return <>
        <div className="container py-2">
            <div className="row pb-2">
                <div className="col gap-1 d-flex overflow-auto justify-content-between">
                    {species.map(x =>
                        <a key={x.key} className={`btn  ${x.key && selectedSpecies.indexOf(x.key) > -1 ? "btn-success" : "btn-default"}`} href="#" onClick={c => { toggleSpecies(x.key); c.preventDefault(); }}>{x.pluralName}</a>
                    )}
                </div>
            </div>
            <div className="row text-black pb-2">
                <div className="col-12 col-sm-5 col-md-3">
                    <select className="form-select" value={selectedStatus} onChange={x => setSelectedStatus(x.target.value)} aria-label={dictionary.get("AnimalSponsorship:Conservation:Placeholder")}>
                        <option value="">{dictionary.get("AnimalSponsorship:Conservation:Placeholder")}</option>
                        {conservation.map(x => <option key={x.key} value={ x.code ?? "" }>{ x.name }</option>)}
                    </select>
                </div>
                <div className="col-12 col-sm-7 col-md-9">
                    <div className="input-group">
                        <input className="form-control" onChange={x=>search(x.target.value)} placeholder={dictionary.get("AnimalSponsorship:Search:Placeholder")} type="text" />
                        <span className="input-group-text" id="Search">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                            </svg>
                        </span>
                    </div>
                </div>
            </div>
            <div className="row pb-2">
                {displayedAnimals.map(x => <AnimalCard key={x.name} animal={x} />)}
            </div>
            {showLoadMore && <div className="row">
                <div className="col-12 d-flex justify-content-center">
                    <a className="btn btn-default border-1" href={"#"} onClick={e=> {e.preventDefault(); pageIncrement()}}>{dictionary.get("AnimalSponsorship:LoadMore")}</a>
                </div>
            </div> }
        </div>
    </>
}